module.exports = __webpack_public_path__ + "images/a45214194550e91c3645e1a5a57b4363.png";